export const getters = {
  getExtraGames(state) {
    return state.extraGames
  },
  getClassConversationMissions(state) {
    return state.classConversationMissions
  }
}
